import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { tablerArrowLeft } from '@ng-icons/tabler-icons';

@Component({
  selector: 'oc-superadmin-container',
  standalone: true,
  imports: [CommonModule, RouterModule, NgIconComponent],
  providers: [
    provideIcons({
      tablerArrowLeft,
    }),
  ],
  template: `
    <div class="d-flex">
      <div class="oc-menu">
        <div>
          <a [routerLink]="['/dashboard']" class="mt-1 mb-3 btn btn-secondary btn-rounded"
            ><ng-icon name="tablerArrowLeft" size="20"></ng-icon> Dashboard</a
          >
          <h3 class="mt-2 mb-3">Superadmin</h3>
          <ul class="list-group">
            <a
              class="list-group-item list-group-item-action"
              routerLinkActive="active"
              [routerLink]="['/superadmin/schools']"
              >Schools</a
            >
            <a
              class="list-group-item list-group-item-action"
              routerLinkActive="active"
              [routerLink]="['/superadmin/users']"
              >Users</a
            >
            <a
              class="list-group-item list-group-item-action"
              routerLinkActive="active"
              [routerLink]="['/superadmin/invites']"
              >Invites</a
            >
          </ul>
        </div>
      </div>
      <div class="flex-grow-1">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: ``,
})
export class SuperadminContainerComponent {}
